import { ILinkConfig } from '@creditflowresearch/uilib/Links';
import URL from '@/creditflowresearch/Router/urlConstants';

export const CAREER_PORTAL_URL = 'https://careerportal.creditflowresearch.com';

const headerLinksConfig: ILinkConfig[] = [
  {
    url: URL.EXTERNAL_API,
    dataTest: 'creditFlowApi',
    label: 'API',
  },
  {
    url: CAREER_PORTAL_URL,
    dataTest: 'careerPortal',
    label: 'Career Portal',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    url: URL.PRICING,
    dataTest: 'pricing',
    label: 'Pricing',
  },
];

export default headerLinksConfig;
